/**
 * railLayout — how much horizontal space the docked Outliner rail is occupying
 * on the left edge of the viewport.
 *
 * Exists because the rail (ENG-895) is the first PERSISTENT chrome on that
 * edge, and three transient overlays already lived there: LightingStatusChip,
 * ProbeReadoutHUD, and App's Print String messages. They were all authored
 * against a clear viewport and now render underneath the rail — same z-index,
 * so DOM order silently decides the winner.
 *
 * A module singleton rather than prop drilling: the width depends on the rail's
 * own collapsed state, which is its private concern, and the consumers are
 * scattered across the tree with no common owner below App. Same pattern as
 * liveTuneStore / sceneSelection / debugState.
 *
 * Consumers should add `inset` to their `left`, not replace it — each keeps its
 * own margin. Width is 0 whenever the rail isn't mounted, so nothing moves for
 * users who never open it (?tune=1 gated).
 */

let _width = 0
const _listeners = new Set()

export const railLayout = {
  /** Occupied width in px — 0 when the rail is not mounted. */
  getWidth() { return _width },

  setWidth(px) {
    const next = Number.isFinite(px) ? Math.max(0, px) : 0
    if (next === _width) return
    _width = next
    if (typeof window !== 'undefined') window.__RAIL_LAYOUT__ = { width: _width, listeners: _listeners.size }
    for (const fn of _listeners) { try { fn() } catch { /* a bad listener must not break layout */ } }
  },

  subscribe(fn) {
    _listeners.add(fn)
    return () => _listeners.delete(fn)
  },
}
